<template>
    <div
        class="relative mx-auto h-[438px] w-[312px] bg-[url(/assets/art/cmspage_ad_bg.png)] bg-cover"
    >
        <div
            class="absolute bottom-0 left-0 right-0 top-0 z-0 overflow-hidden bg-[url(/assets/art/emtprep_upsell_bg.png)] bg-right-bottom bg-no-repeat"
        ></div>
        <img class="" src="" />
        <div
            class="z-10 flex h-full flex-col px-6 pb-8 pt-3 text-center text-white"
        >
            <div class="z-10 mb-6 font-medium">Studying for the NREMT?</div>
            <div class="z-10 text-[16px] leading-7">
                We've helped over
                <span class="handwritten-underline-sm font-bold"> 200K+ </span>
                students pass their NREMT, all for just $39/month
            </div>
            <div class="z-10 flex-grow"></div>
            <div class="z-10">
                <Link
                    :href="route('frontend.home')"
                    class="btn btn-primary block text-center"
                >
                    Learn more about EMTprep
                </Link>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "emtprep-upsell-ad",
};
</script>
